import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

import type { DeleteFavoriteItemsModalProps } from './type'

import { DialogWarning, ErrorMessageList } from '@/components/ui'

export const DeleteFavoriteItemsModal = ({
  isOpen = false,
  favoriteName,
  isMutatingDelete = false,
  errorMessages = [],
  onClose,
  onDelete,
}: DeleteFavoriteItemsModalProps) => {
  const { t } = useTranslation()

  return (
    <DialogWarning
      title={t('favorite.modal.delete_title')}
      isOpen={isOpen}
      bodyText={
        <div className={clsx('tw-w-full', 'tw-flex tw-flex-col', 'tw-gap-4')}>
          {errorMessages.length > 0 && (
            <div className={clsx('tw-mb-2 tw-text-center')}>
              <ErrorMessageList errorMessages={errorMessages} />
            </div>
          )}
          <p className={clsx('tw-text-center tw-text-xs')}>
            {t('favorite.item.remove_description.line1')}
            <br />
            {t('favorite.item.remove_description.line2', {
              name: favoriteName,
            })}
          </p>
          <p className={clsx('tw-text-center tw-text-xs')}>
            {t('favorite.modal.delete_description')}
          </p>
        </div>
      }
      isLoading={isMutatingDelete}
      confirmButtonText={t('common.action.delete')}
      onCancel={onClose}
      onConfirm={onDelete}
    />
  )
}
